import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import Header from '../components/Header';
import Footer from '../components/Footer';
import './Register.css';

const RegisterStudent = () => {
  const [formData, setFormData] = useState({
    username: '',
    email: '',
    password: '',
    password2: '',
  });
  const [error, setError] = useState('');
  const [passwordError, setPasswordError] = useState('');
  const { register } = useAuth();
  const navigate = useNavigate();

  const validatePassword = (password) => {
    const errors = [];
    if (password.length < 8) {
      errors.push('Пароль должен содержать минимум 8 символов');
    }
    if (!/[A-ZА-Я]/.test(password)) {
      errors.push('Пароль должен содержать хотя бы одну заглавную букву');
    }
    if (!/[a-zа-я]/.test(password)) {
      errors.push('Пароль должен содержать хотя бы одну строчную букву');
    }
    if (!/[0-9]/.test(password)) {
      errors.push('Пароль должен содержать хотя бы одну цифру');
    }
    if (!/[!@#$%^&*(),.?":{}|<>]/.test(password)) {
      errors.push('Пароль должен содержать хотя бы один специальный символ (!@#$%^&* и т.д.)');
    }
    return errors;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
    
    if (name === 'password') {
      const errors = validatePassword(value);
      setPasswordError(errors.length > 0 ? errors.join('. ') : '');
    } else if (name === 'password2') {
      if (value && value !== formData.password) {
        setPasswordError('Пароли не совпадают');
      } else if (value && formData.password) {
        const errors = validatePassword(formData.password);
        setPasswordError(errors.length > 0 ? errors.join('. ') : '');
      }
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    const passwordErrors = validatePassword(formData.password);
    if (passwordErrors.length > 0) {
      setError(passwordErrors.join('. '));
      return;
    }

    if (formData.password !== formData.password2) {
      setError('Пароли не совпадают');
      return;
    }

    const result = await register(formData, 'student');
    if (result.success) {
      if (result.requires_email_verification) {
        navigate('/verify-email');
      } else {
        navigate('/dashboard');
      }
    } else {
      setError(result.error || 'Ошибка регистрации');
    }
  };

  return (
    <div className="auth-page">
      <Header />
      <div className="register-container">
        <div className="register-box">
        <h2>Регистрация ученика</h2>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Имя пользователя</label>
            <input
              type="text"
              name="username"
              value={formData.username}
              onChange={handleChange}
              required
            />
          </div>
          <div className="form-group">
            <label>Email</label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
            />
          </div>
          <div className="form-group">
            <label>Пароль</label>
            <input
              type="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
              required
            />
            {passwordError && formData.password && <div className="password-error">{passwordError}</div>}
          </div>
          <div className="form-group">
            <label>Подтвердите пароль</label>
            <input
              type="password"
              name="password2"
              value={formData.password2}
              onChange={handleChange}
              required
            />
          </div>
          {error && <div className="error">{error}</div>}
          <button type="submit" className="btn-primary">Зарегистрироваться</button>
        </form>
        <div className="login-link">
          <Link to="/login">Уже есть аккаунт? Войти</Link>
        </div>
        <div className="register-link">
          <Link to="/register/teacher">Зарегистрироваться как преподаватель</Link>
        </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default RegisterStudent;

